/* eslint-disable */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import Moment from "moment";
import { cloneDeep } from "lodash";
import queryString from "query-string";
import pickBy from "lodash/pickBy";
import isEqual from "lodash/isEqual";
import { ObjToParam } from "helper/helper-api";
import {
  formatTimezoneDateTime,
  initialSizePerPage,
  dispatchActionSetPageSizeReference
} from "helper/unit-helper";
import TableList from "components/TableList";
import LotFilter from "../Components/lot-filter";
import { ContextMenu } from "../../components/context-menu/context-menu";
import { MessengerBox } from "../../components/messenger-box/messenger-box";
import { AppSettings } from "../../constants";
import * as LotActionType from "../constants";
import * as RegionActionType from "Region-Market/constants";
import * as ProjectActionType from "Projects/constants";
import * as BuilderActionType from "Builders/constants";
import * as HomeownerActionType from "HomeOwners/constants";
import * as ModelActionType from "Model/constants";
import * as InsuranceActionType from "Insurance/constants";
import { ChangeColumn } from "components/change-column";
import AddNewLotModal from "../Components/add-new-lot-modal";
import style from "../lot.scss";
import Translate from "components/translate";
import AdvancedSort from "../Components/AdvancedSort";
import { SortCaret } from "../Components/SortCaret";
import { ExportButton } from "Work-Orders/Components/ExportButton";

const defaultParams = {
  defaultSortName: "projectName",
  defaultSortOrder: "ascending",
  defaultThenField: "phase",
  defaultThenOrder: "ascending",
  defaultEndField: "name",
  defaultEndOrder: "ascending",
  sizePerPage: 10
};

const orderSelectList = [
  { value: "ascending", text: "Ascending" },
  { value: "descending", text: "Descending" }
];

const TABLE_NAME = "LOT_LIST";

class CreateNewLot extends Component {
  constructor(props) {
    super(props);

    this.sizePerPage = initialSizePerPage(
      TABLE_NAME,
      props.PageSizeReference,
      props.LotStore.ManageLots.params.take
    );

    this.defaultColumnList = [
      {
        field: "id",
        header: "id",
        hidden: true,
        isKey: true,
        sort: false,
        dataAlign: "left",
        headerAlign: "left"
      },
      {
        field: "projectName",
        header: (
          <Translate
            id="lots-column-project-key"
            translateKey="project"
            capitalize
          />
        ),
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: "left",
        headerAlign: "left",
        width: "150px"
      },
      {
        field: "phase",
        header: "Phase",
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: "left",
        headerAlign: "left",
        width: "110px"
      },
      {
        field: "name",
        header: (
          <span>
            <Translate id="lots-column-lot-key" translateKey="lot" capitalize />{" "}
            #
          </span>
        ),
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: "left",
        headerAlign: "left",
        width: "100px"
      },
      {
        field: "streetAddress",
        header: "Address",
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: "left",
        headerAlign: "left",
        width: "250px"
      },
      {
        field: "coe",
        header: "Original COE",
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: "left",
        headerAlign: "left",
        customRender: this.customRenderCOE.bind(this),
        width: "100px"
      },
      {
        field: "homeowner",
        header: (
          <Translate
            id="lots-column-homeowner-key"
            translateKey="homeowner"
            capitalize
          />
        ),
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: "left",
        headerAlign: "left",
        customRender: this.customRenderHomeowner.bind(this),
        width: "150px"
      },
      {
        field: 'numberOfWOs',
        header: '# of WOs',
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: 'left',
        headerAlign: 'left',
        width: '100px'
      },
      {
        field: "numberOfOpenWOs",
        header: "Open",
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: "left",
        headerAlign: "left",
        width: "100px"
      },
      {
        field: "numberOfOverdueWOs",
        header: "Overdue",
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: "left",
        headerAlign: "left",
        width: "100px"
      },
      {
        field: "",
        header: "",
        hidden: false,
        isKey: false,
        sort: false,
        dataAlign: "right",
        headerAlign: "right",
        customRender: this.customRenderBtnAction.bind(this),
        className: "column-action",
        columnClassName: "column-action",
        width: "60px"
      }
    ];

    this.queryParams = queryString.parse(this.props.location.search);

    this.defaultSortBy = {
      value: defaultParams.defaultSortName,
      text: "Project"
    };
    if (this.queryParams.sortField) {
      this.defaultSortBy = this.processAdvanceSortSelect(
        this.defaultColumnList.find(x => x.field === this.queryParams.sortField)
      );
    }

    this.defaultSortByOrder = orderSelectList[0];
    if (this.queryParams.sortOrder) {
      this.defaultSortByOrder = orderSelectList.find(
        x => x.value === this.queryParams.sortOrder
      );
    }

    this.defaultSortThen = {
      value: defaultParams.defaultThenField,
      text: "Phase"
    };
    if (this.queryParams.ThenSortField) {
      this.defaultSortThen = this.processAdvanceSortSelect(
        this.defaultColumnList.find(
          x => x.field === this.queryParams.ThenSortField
        )
      );
    }

    this.defaultSortThenOrder = orderSelectList[0];
    if (this.queryParams.ThenSortOrder) {
      this.defaultSortThenOrder = orderSelectList.find(
        x => x.value === this.queryParams.ThenSortOrder
      );
    }

    this.defaultSortEnd = {
      value: defaultParams.defaultEndField,
      text: "Lot#"
    };
    if (this.queryParams.EndSortField) {
      this.defaultSortEnd = this.processAdvanceSortSelect(
        this.defaultColumnList.find(
          x => x.field === this.queryParams.EndSortField
        )
      );
    }

    this.defaultSortEndOrder = orderSelectList[0];
    if (this.queryParams.EndSortOrder) {
      this.defaultSortEndOrder = orderSelectList.find(
        x => x.value === this.queryParams.EndSortOrder
      );
    }

    this.state = {
      sizePerPage: this.queryParams.take
        ? Number(this.queryParams.take)
        : this.sizePerPage,
      currentPage: this.queryParams.skip
        ? Number(this.queryParams.skip)
        : props.LotStore.ManageLots.params.skip,
      totalRecord: props.LotStore.ManageLots.params.totalRecord,
      defaultSortName: this.queryParams.sortField
        ? this.queryParams.sortField
        : defaultParams.defaultSortName,
      defaultSortOrder: this.queryParams.sortOrder
        ? this.queryParams.sortOrder
        : defaultParams.defaultSortOrder,
      defaultThenField: defaultParams.defaultThenField, // default then column name
      defaultThenOrder: defaultParams.defaultThenOrder, // default then order,
      defaultEndField: defaultParams.defaultEndField, // default end column name
      defaultEndOrder: defaultParams.defaultEndOrder, // default end order,
      searchTxt: this.queryParams.searchKey || "",
      isShowPopup: false,
      paramFilter: null,
      column: this.defaultColumnList,
      settingColumn: [],
      isOpenAddModal: false,
      isDisplayAdvancedMenu: false,
      isDisplayAdvancedSortDialog: false,
      sortBy: this.defaultSortBy,
      sortByOrder: this.defaultSortByOrder,
      then: this.defaultSortThen,
      thenOrder: this.defaultSortThenOrder,
      end: this.defaultSortEnd,
      endOrder: this.defaultSortEndOrder,
      currentSortBy: this.defaultSortBy,
      currentSortByOrder: this.defaultSortByOrder,
      currentThen: this.defaultSortThen,
      currentThenOrder: this.defaultSortThenOrder,
      currentEnd: this.defaultSortEnd,
      currentEndOrder: this.defaultSortEndOrder,
      isUsingSecondarySort: true,

      isDisplayTable: true
    };
  }

  componentDidMount() {
    const {
      defaultSortName,
      defaultSortOrder,
      defaultThenField,
      defaultThenOrder,
      defaultEndField,
      defaultEndOrder
    } = this.state;

    if (this.queryParams.skip) {
      this.binding({
        ...this.objToParams({
          ...this.queryParams,
          skip: this.queryParams.skip ? this.queryParams.skip : 1
        })
      });
    } else {
      this.binding({
        ...this.objToParams({
          ...this.props.LotStore.ManageLots.params,
          take: this.state.sizePerPage,
          sort: {
            ...this.props.LotStore.ManageLots.params.sort,
            field: defaultSortName,
            order: defaultSortOrder
          }
        }),
        ThenSortField: defaultThenField,
        ThenSortOrder: defaultThenOrder,
        EndSortField: defaultEndField,
        EndSortOrder: defaultEndOrder
      });
    }

    if (this.queryParams.take) {
      dispatchActionSetPageSizeReference(
        this.props.dispatch,
        TABLE_NAME,
        Number(this.queryParams.take)
      );
    }

    if (
      this.props.UserProfile &&
      this.props.UserProfile.userId &&
      this.props.SettingDataGridColumn
    ) {
      this.setDefaultColumn(
        this.props.UserProfile.userId,
        this.props.SettingDataGridColumn
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    const { ManageLots } = nextProps.LotStore;
    if (ManageLots) {
      this.setState({
        totalRecord: ManageLots.params.totalRecord,
        currentPage: ManageLots.params.skip
      });

      let pagingButtons = document.getElementsByClassName("page-link");

      Array.prototype.forEach.call(pagingButtons, el => {
        el.blur();
      });
    }

    if (
      nextProps.UserProfile &&
      nextProps.UserProfile.userId &&
      nextProps.SettingDataGridColumn
    ) {
      this.setDefaultColumn(
        nextProps.UserProfile.userId,
        nextProps.SettingDataGridColumn
      );
    }
    const urlParams = queryString.parse(nextProps.location.search);

    if (typeof urlParams.searchKey !== "undefined") {
      this.setState({ searchTxt: urlParams.searchKey });
    } else {
      this.setState({ searchTxt: "" });
    }

    if (urlParams.ThenSortField && !this.state.isUsingSecondarySort) {
      this.setState({ isUsingSecondarySort: true });
    }

    if (!urlParams.ThenSortField && this.state.isUsingSecondarySort) {
      this.setState({ isUsingSecondarySort: false });
    }

    if (!urlParams.skip) {
      this.setState({
        isUsingSecondarySort: true,
        defaultSortName: defaultParams.defaultSortName,
        defaultSortOrder: defaultParams.defaultSortOrder,
        sortBy: this.defaultSortBy,
        sortByOrder: this.defaultSortByOrder,
        then: this.defaultSortThen,
        thenOrder: this.defaultSortThenOrder,
        end: this.defaultSortEnd,
        endOrder: this.defaultSortEndOrder,
        currentSortBy: this.defaultSortBy,
        currentSortByOrder: this.defaultSortByOrder,
        currentThen: this.defaultSortThen,
        currentThenOrder: this.defaultSortThenOrder,
        currentEnd: this.defaultSortEnd,
        currentEndOrder: this.defaultSortEndOrder
      });
    }

    if (
      urlParams.sortField &&
      urlParams.sortField !== this.state.defaultSortName
    ) {
      this.setState({ defaultSortName: urlParams.sortField });
    }

    if (
      urlParams.sortOrder &&
      urlParams.sortOrder !== this.state.defaultSortOrder
    ) {
      this.setState({ defaultSortOrder: urlParams.sortOrder });
    }
    let urlSortField = urlParams.sortField
      ? this.processAdvanceSortSelect(
          this.state.column.find(x => x.field === urlParams.sortField)
        )
      : null;
    if (!urlParams.skip) {
      urlSortField = this.defaultSortBy;
    }
    if (!isEqual(urlSortField, this.state.sortBy)) {
      this.setState({
        sortBy: urlSortField,
        currentSortBy: urlSortField
      });
    }

    let urlThenField = urlParams.ThenSortField
      ? this.processAdvanceSortSelect(
          this.state.column.find(x => x.field === urlParams.ThenSortField)
        )
      : null;
    if (!urlParams.skip) {
      urlThenField = this.defaultSortThen;
    }
    if (!isEqual(urlThenField, this.state.then)) {
      this.setState({
        then: urlThenField,
        currentThen: urlThenField
      });
    }

    let urlEndField = urlParams.EndSortField
      ? this.processAdvanceSortSelect(
          this.state.column.find(x => x.field === urlParams.EndSortField)
        )
      : null;
    if (!urlParams.skip) {
      urlEndField = this.defaultSortEnd;
    }
    if (!isEqual(urlEndField, this.state.end)) {
      this.setState({
        end: urlEndField,
        currentEnd: urlEndField
      });
    }

    const urlSortOrder = urlParams.sortOrder
      ? orderSelectList.find(x => x.value === urlParams.sortOrder)
      : orderSelectList[0];
    if (!isEqual(urlSortOrder, this.state.sortOrder)) {
      this.setState({
        sortOrder: urlSortOrder,
        currentSortOrder: urlSortOrder
      });
    }

    const urlThenOrder = urlParams.ThenSortOrder
      ? orderSelectList.find(x => x.value === urlParams.ThenSortOrder)
      : orderSelectList[0];
    if (!isEqual(urlThenOrder, this.state.thenOrder)) {
      this.setState({
        thenOrder: urlThenOrder,
        currentThenOrder: urlThenOrder
      });
    }

    const urlEndOrder = urlParams.EndSortOrder
      ? orderSelectList.find(x => x.value === urlParams.EndSortOrder)
      : orderSelectList[0];
    if (!isEqual(urlEndOrder, this.state.endOrder)) {
      this.setState({
        endOrder: urlEndOrder,
        currentEndOrder: urlEndOrder
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.sizePerPage !== this.state.sizePerPage) {
      dispatchActionSetPageSizeReference(
        this.props.dispatch,
        TABLE_NAME,
        this.state.sizePerPage
      );
    }

    if (!isEqual(this.props.location.search, prevProps.location.search)) {
      let urlParams = queryString.parse(this.props.location.search);

      const {
        LotStore: {
          ManageLots: { params }
        }
      } = this.props;

      if (urlParams.skip) {
        this.binding(
          this.objToParams({
            ...params,
            ...urlParams,
            skip: urlParams.skip
          })
        );
      } else {
        const { sizePerPage } = this.state;

        this.binding(
          this.objToParams({
            sortField: defaultParams.defaultSortName,
            sortOrder: defaultParams.defaultSortOrder,
            ThenSortField: defaultParams.defaultThenField,
            ThenSortOrder: defaultParams.defaultThenOrder,
            EndSortField: defaultParams.defaultEndField,
            EndSortOrder: defaultParams.defaultEndOrder,
            skip: 1,
            take: sizePerPage
          })
        );
      }
    }
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: LotActionType.RESET_LOT,
      params: null
    });
  }

  setDefaultColumn = (userId, settingDataGridColumnProps) => {
    if (
      settingDataGridColumnProps.hasOwnProperty(userId) &&
      settingDataGridColumnProps[userId].hasOwnProperty("LOT_COLUMN")
    ) {
      const selectedColumnFields =
        settingDataGridColumnProps[userId].LOT_COLUMN;
      this.setState({ settingColumn: selectedColumnFields });
      const newColumnState = [...this.state.column];
      newColumnState.map(column => {
        if (column.field !== "" && column.field !== "id") {
          if (selectedColumnFields.indexOf(column.field) !== -1) {
            column.hidden = false;
          } else {
            column.hidden = true;
          }
        }
      });
      this.setState({ column: newColumnState });
    }
  };

  onContextMenu(e, item) {
    var contextItem = [
      {
        title: "View details",
        icon: "glyphicon glyphicon-pencil",
        event: this.onViewDetail.bind(this)
      },
      {
        title: "Add request for service",
        icon: "glyphicon glyphicon-pencil",
        event: this.onAddRFS.bind(this)
      }
      // {
      //   title: 'Reassign subcontractor',
      //   icon: 'glyphicon glyphicon-pencil',
      //   event: this.onReassignSubcontractor.bind(this)
      // }
    ];

    this.cxtMenu.state.event(e, item, contextItem);
  }

  onViewDetail(e, item) {
    this.props.history.push(`/lots/${item.id}`);
  }

  onAddRFS(e, item) {
    const params = {
      isFromLot: true,
      lotId: item.id,
      lotNumber: item.name,
      coe: item.coe,
      streetAddress: item.streetAddress,
      projectId: item.projectId,
      projectName: item.projectName
    };
    this.props.history.push(`/request-for-services/add?${ObjToParam(params)}`);
  }

  // onReassignSubcontractor(e, item) {
  //   alert('Not implemented yet!');
  // }

  customRenderName(item) {
    var style = {};

    if (!item.isActive) {
      style = { opacity: 0.5 };
    }

    return <span style={style}>{item.name}</span>;
  }

  binding(params) {
    this.props.dispatch({
      type: LotActionType.SEARCH_LOT_ASYNC,
      params: params
    });
  }

  onTableBinding(configTable) {
    var params = this.objToParams(this.props.LotStore.ManageLots.params);

    this.binding({
      ...params,
      sortField: configTable.sort.field,
      sortOrder: configTable.sort.order,
      skip: configTable.page.skip - 1,
      take: configTable.page.take
    });
  }

  objToParams(obj) {
    const urlParams = queryString.parse(this.props.location.search);
    return {
      searchKey:
        typeof urlParams.searchKey !== "undefined"
          ? urlParams.searchKey
          : this.state.searchTxt.trim(),
      sortField: obj.sortField ? obj.sortField : obj.sort.field,
      sortOrder: obj.sortOrder ? obj.sortOrder : obj.sort.order,
      ThenSortField: obj.ThenSortField || "",
      ThenSortOrder: obj.ThenSortOrder || "",
      EndSortField: obj.EndSortField || "",
      EndSortOrder: obj.EndSortOrder || "",
      skip: obj.skip - 1,
      take: obj.take,
      RegionIds: this.processMultiParams(obj.inRegions),
      MarketIds: this.processMultiParams(obj.inMarkets),
      ProjectIds: this.processMultiParams(obj.inProjects),
      status: obj.status || "",
      HomeownerUserIds: this.processMultiParams(obj.inHomeowners),
      COEDateFrom: obj.COEDateFrom || "",
      COEDateTo: obj.COEDateTo || "",
      datetime: formatTimezoneDateTime(Moment())
    };
  }

  processMultiParams = stringParams => {
    let params = [];
    if (stringParams) {
      const parsedParams = queryString.parse(stringParams);

      Object.keys(parsedParams).map(el => {
        params.push(queryString.parse(parsedParams[el]).value);
      });
    }
    return params.toString();
  };

  onTogglePopupFilter = e => {
    this.setState({
      isShowPopup: !this.state.isShowPopup
    });
  };

  onSearch() {
    let urlParams = queryString.parse(this.props.location.search);

    const {
      searchTxt,
      defaultSortName,
      defaultSortOrder,
      sizePerPage
    } = this.state;

    urlParams["searchKey"] = searchTxt.trim();
    urlParams["sortField"] = defaultSortName;
    urlParams["sortOrder"] = defaultSortOrder;
    urlParams["skip"] = 1;
    urlParams["take"] = sizePerPage;
    urlParams = pickBy(urlParams);

    this.props.history.push({
      search: queryString.stringify(urlParams)
    });
  }

  onEnter(e) {
    if (e.key === "Enter") {
      this.onSearch(e);
    }
  }

  onFetchRegion = () => {
    this.props.dispatch({
      type: RegionActionType.GET_LIST_REGION_ASYNC,
      params: {
        searchKey: "",
        selectedValue: ""
      }
    });
  };

  onFetchMarket = () => {
    this.props.dispatch({
      type: RegionActionType.GET_LIST_MARKET_ASYNC,
      params: {
        searchKey: "",
        selectedValue: ""
      }
    });
  };

  onFetchProject = () => {
    this.props.dispatch({
      type: ProjectActionType.SELECT_LIST_PROJECT_ASYNC,
      params: {
        param: { searchKey: "", selectedValue: "" }
      }
    });
  };

  onFetchHomeowner = () => {
    this.props.dispatch({
      type: HomeownerActionType.GET_SELECT_LIST_HOMEOWNER_ASYNC,
      params: {
        searchKey: "",
        selectedValue: ""
      }
    });
  };

  onFetchPhase = projectId => {
    this.props.dispatch({
      type: ProjectActionType.GET_LIST_PHASE_BY_PROJECT_ASYNC,
      params: { projectId, searchKey: "", selectedValue: "" }
    });
  };

  onFetchPlan = projectId => {
    this.props.dispatch({
      type: ModelActionType.GET_LIST_MODEL_BY_PROJECT_ASYNC,
      params: { projectId, searchKey: "", selectedValue: "" }
    });
  };

  onFetchCostCode = projectId => {
    this.props.dispatch({
      type: LotActionType.GET_LIST_COST_CODE_ASYNC,
      params: {projectId}
    });
  }
  onFetchInsurance = () => {
    this.props.dispatch({
      type: InsuranceActionType.GET_SELECT_LIST_INSURANCE_POLICY_ASYNC,
      params: {
        searchKey: "",
        selectedValue: ""
      }
    });
  };

  onCloseModalAddNewLot = () => {
    this.setState({
      isOpenAddModal: false
    });
  };

  onSubmitModalAddNewLot = (data, isCreateAnother) => {
    this.props.dispatch({
      type: LotActionType.CREATE_LOT_ASYNC,
      params: {
        data
      },
      paramFilter: {
        ...this.state.paramFilter,
        searchKey: "",
        sortField: this.state.defaultSortName,
        sortOrder: this.state.defaultSortOrder,
        skip: this.state.currentPage - 1,
        take: this.state.sizePerPage,
        datetime: formatTimezoneDateTime(Moment())
      },
      callback: () => {
        if (isCreateAnother) {
          this.addModal.resetCreateAnother();
        } else {
          this.setState(
            {
              isOpenAddModal: false
            },
            () => {
              this.addModal.resetForm();
            }
          );
        }
      }
    });
  };

  toolTip(message) {
    return (
      <Tooltip
        className="in tooltip-siteone"
        placement="top"
        id="tooltip"
        positionLeft={0}
        arrowOffsetLeft={0}
      >
        <span>{message}</span>
      </Tooltip>
    );
  }

  customRenderCOE = item => {
    if (item.coe) {
      return <span>{Moment(item.coe).format("MM/DD/YYYY")}</span>;
    } else {
      return null;
    }
  };

  customRenderHomeowner = item => {
    return (
      <OverlayTrigger
        placement="top"
        overlay={this.toolTip(item.homeowner)}
        delayHide={10}
        delayShow={500}
      >
        <div>{item.homeowner}</div>
      </OverlayTrigger>
    );
  };

  customRenderBtnAction(item) {
    return (
      <a
        className="glyphicon glyphicon-option-vertical cls-table-black-icon"
        onClick={e => {
          this.onContextMenu(e, item);
        }}
      />
    );
  }

  onSearchLot = data => {
    const {
      LotStore: {
        ManageLots: { params }
      }
    } = this.props;

    const { defaultSortName, defaultSortOrder } = this.state;
    let filterParams = Object.assign({ ...params }, data);

    delete filterParams.totalPage;
    delete filterParams.totalRecord;
    delete filterParams.sort;
    filterParams.sortField = defaultSortName;
    filterParams.sortOrder = defaultSortOrder;
    filterParams = pickBy(filterParams);

    this.props.history.push({
      search: queryString.stringify({
        ...filterParams,
        skip: 1
      })
    });
  };

  refreshList(params) {
    const { defaultSortOrder, defaultSortName, column } = this.state;
    //on sort => reset secondary sort
    if (
      params.defaultSortOrder !== defaultSortOrder ||
      params.defaultSortName !== defaultSortName
    ) {
      this.setState(
        {
          defaultSortName: params.defaultSortName,
          defaultSortOrder: params.defaultSortOrder,
          sizePerPage: params.sizePerPage,
          sortBy: this.processAdvanceSortSelect(
            column.find(x => x.field === params.defaultSortName)
          ),
          sortByOrder: {
            value: params.defaultSortOrder,
            text: params.defaultSortOrder.charAt(0).toUpperCase()
          },
          then: null,
          end: null,
          currentSortBy: this.processAdvanceSortSelect(
            column.find(x => x.field === params.defaultSortName)
          ),
          currentSortByOrder: {
            value: params.defaultSortOrder,
            text: params.defaultSortOrder.charAt(0).toUpperCase()
          },
          currentThen: null,
          currentEnd: null,
          isUsingSecondarySort: false
        },
        () => {
          let urlParams = queryString.parse(this.props.location.search);
          urlParams["searchKey"] = this.state.searchTxt.trim();
          urlParams["sortField"] = params.defaultSortName;
          urlParams["sortOrder"] = params.defaultSortOrder;
          urlParams["skip"] = params.currentPage;
          urlParams["take"] = params.sizePerPage;
          delete urlParams.ThenSortField;
          delete urlParams.ThenSortOrder;
          delete urlParams.EndSortField;
          delete urlParams.EndSortOrder;
          urlParams = pickBy(urlParams);

          this.props.history.push({
            search: queryString.stringify(urlParams)
          });
        }
      );
    } else {
      //on change page number or change size per page => keep current secondary sort
      this.setState(
        {
          defaultSortName: params.defaultSortName,
          defaultSortOrder: params.defaultSortOrder,
          sizePerPage: params.sizePerPage,
          currentPage: params.currentPage,
          sortBy: {
            value: params.defaultSortName,
            text: params.defaultSortName
          },
          sortByOrder: {
            value: params.defaultSortOrder,
            text: params.defaultSortOrder.charAt(0).toUpperCase()
          },
          currentSortBy: {
            value: params.defaultSortName,
            text: params.defaultSortName
          },
          currentSortByOrder: {
            value: params.defaultSortOrder,
            text: params.defaultSortOrder.charAt(0).toUpperCase()
          }
        },
        () => {
          let urlParams = queryString.parse(this.props.location.search);
          urlParams["searchKey"] = this.state.searchTxt.trim();
          urlParams["sortField"] = params.defaultSortName;
          urlParams["sortOrder"] = params.defaultSortOrder;

          const {
            currentThen,
            currentThenOrder,
            currentEnd,
            currentEndOrder
          } = this.state;

          if (!urlParams.skip) {
            urlParams["ThenSortField"] = currentThen.value;
            urlParams["ThenSortOrder"] = currentThenOrder.value;
            urlParams["EndSortField"] = currentEnd.value;
            urlParams["EndSortOrder"] = currentEndOrder.value;
          }

          urlParams["skip"] = params.currentPage;
          urlParams["take"] = params.sizePerPage;
          urlParams = pickBy(urlParams);

          this.props.history.push({
            search: queryString.stringify(urlParams)
          });
        }
      );
    }
  }

  onChangeColumn = (newColumn, selectedColumnField) => {
    this.setState({ isDisplayTable: false }, () => {
      this.props.dispatch({
        type: BuilderActionType.SET_SELECT_COLUMN,
        params: {
          id: this.props.UserProfile.userId,
          type: "LOT_COLUMN",
          data: selectedColumnField
        }
      });

      setTimeout(() => {
        this.setState({ isDisplayTable: true });
      }, 200);
    });
  };

  handleClickAdvancedButton = () => {
    this.setState({
      isDisplayAdvancedSortDialog: !this.state.isDisplayAdvancedSortDialog
    });
  };

  onSelectChange = (event, name) => {
    const { then, end } = this.state;

    if (name === "sortBy" && then && event.value.value === then.value) {
      this.setState({
        [name]: event.value,
        then: null
      });
    } else if (name === "then" && end && event.value.value === end.value) {
      this.setState({
        [name]: event.value,
        end: null
      });
    } else {
      this.setState({
        [name]: event.value
      });
    }
  };

  onChangeSearchTxt = e => {
    this.setState({ searchTxt: e.target.value });
  };

  handleApplyAdvancedSort = () => {
    const {
      sortBy,
      then,
      end,
      sortByOrder,
      thenOrder,
      endOrder,
      sizePerPage
    } = this.state;

    const sortField = sortBy.value;
    const sortOrder = sortByOrder.value;

    const ThenSortField = then.value;
    const ThenSortOrder = thenOrder.value;

    let urlParams = queryString.parse(this.props.location.search);
    urlParams["searchKey"] = this.state.searchTxt.trim();
    urlParams["sortField"] = sortField;
    urlParams["sortOrder"] = sortOrder;
    urlParams["ThenSortField"] = ThenSortField;
    urlParams["ThenSortOrder"] = ThenSortOrder;

    if (end && endOrder) {
      urlParams["EndSortField"] = end.value;
      urlParams["EndSortOrder"] = endOrder.value;
    }

    urlParams["skip"] = 1;
    urlParams["take"] = sizePerPage;
    urlParams = pickBy(urlParams);

    this.setState(
      {
        isDisplayAdvancedSortDialog: false,
        isUsingSecondarySort: true,
        defaultSortName: sortField,
        defaultSortOrder: sortOrder,
        currentSortBy: sortBy,
        currentSortByOrder: sortByOrder,
        currentThen: then,
        currentThenOrder: thenOrder,
        currentEnd: end,
        currentEndOrder: endOrder
      },
      () => {
        this.props.history.push({
          search: queryString.stringify(urlParams)
        });
      }
    );
  };

  capitalize = text => {
    return text.charAt(0).toUpperCase() + text.slice(1);
  };

  handleExport = () => {
    const {
      LotStore: {
        ManageLots: { params }
      }
    } = this.props;

    let urlParams = queryString.parse(this.props.location.search);

    let exportParams = {};

    if (urlParams.skip) {
      exportParams = { ...urlParams, skip: 1, take: "" };
    } else {
      exportParams = { ...params, skip: 1, take: "" };
    }

    this.props.dispatch({
      type: LotActionType.EXPORT_LOT_LIST,
      params: {
        ...this.objToParams({
          ...exportParams
        })
      }
    });
  };

  processAdvanceSortSelect = col => {
    let item = {};

    switch (col.field) {
      case "projectName":
        const projectKey = document.getElementById("lots-column-project-key");
        item = {
          value: col.field,
          text: projectKey ? this.capitalize(projectKey.innerText) : "Project"
        };
        break;
      case "name":
        const lotKey = document.getElementById("lots-column-lot-key");
        item = {
          value: col.field,
          text: lotKey ? this.capitalize(lotKey.innerText) + " #" : "Lot #"
        };
        break;
      case "homeowner":
        const homeownerKey = document.getElementById(
          "lots-column-homeowner-key"
        );
        item = {
          value: col.field,
          text: homeownerKey
            ? this.capitalize(homeownerKey.innerText)
            : "Homeowner"
        };
        break;
      default:
        item = {
          value: col.field,
          text: col.header
        };
        break;
    }

    return item;
  };

  processSortBySelectList = columns => {
    let sortBySelectList = [];

    columns.map(col => {
      const item = this.processAdvanceSortSelect(col);

      sortBySelectList.push(item);
    });

    return sortBySelectList;
  };

  processThenSelectList = columns => {
    let thenSelectList = [];

    columns.map(col => {
      const item = this.processAdvanceSortSelect(col);

      if (item.value !== this.state.sortBy.value) {
        thenSelectList.push(item);
      }
    });

    return thenSelectList;
  };

  processEndSelectList = columns => {
    let endSelectList = [];

    columns.map(col => {
      const item = this.processAdvanceSortSelect(col);

      const { sortBy, then } = this.state;

      if (
        (then && item.value !== sortBy.value && item.value !== then.value) ||
        (!then && item.value !== sortBy.value)
      ) {
        endSelectList.push(item);
      }
    });

    return endSelectList;
  };

  getCaret = (direction, fieldName) => {
    const {
      defaultSortName,
      defaultSortOrder,
      currentSortBy,
      currentSortByOrder,
      currentThen,
      currentThenOrder,
      currentEnd,
      currentEndOrder,
      isUsingSecondarySort
    } = this.state;

    if (!isUsingSecondarySort) {
      if (fieldName === defaultSortName) {
        if (defaultSortOrder === "ascending") {
          return <SortCaret className="order dropup" />;
        }
        if (defaultSortOrder === "descending") {
          return <SortCaret className="order" />;
        }
      }

      return null;
    } else {
      if (fieldName === currentSortBy.value) {
        if (currentSortByOrder.value === "ascending") {
          return (
            <SortCaret className="order dropup">
              <span style={{ fontSize: 12 }}>1</span>
            </SortCaret>
          );
        }
        if (currentSortByOrder.value === "descending") {
          return (
            <SortCaret className="order">
              <span style={{ fontSize: 12 }}>1</span>
            </SortCaret>
          );
        }
      }

      if (fieldName === currentThen.value) {
        if (currentThenOrder.value === "ascending") {
          return (
            <SortCaret className="order dropup">
              <span style={{ fontSize: 12 }}>2</span>
            </SortCaret>
          );
        }
        if (currentThenOrder.value === "descending") {
          return (
            <SortCaret className="order">
              <span style={{ fontSize: 12 }}>2</span>
            </SortCaret>
          );
        }
      }

      if (currentEnd && fieldName === currentEnd.value) {
        if (currentEndOrder.value === "ascending") {
          return (
            <SortCaret className="order dropup">
              <span style={{ fontSize: 12 }}>3</span>
            </SortCaret>
          );
        }
        if (currentEndOrder.value === "descending") {
          return (
            <SortCaret className="order">
              <span style={{ fontSize: 12 }}>3</span>
            </SortCaret>
          );
        }
      }

      return null;
    }
  };

  render() {
    const data = this.props.LotStore.ManageLots.items;

    const {
      column,
      isDisplayAdvancedSortDialog,
      sortBy,
      sortByOrder,
      then,
      thenOrder,
      end,
      endOrder,
      searchTxt,
      defaultSortName,
      defaultSortOrder,
      sizePerPage,
      totalRecord,
      currentPage
    } = this.state;

    const cloneDeepColumn = cloneDeep(column).filter(
      col => !col.hidden && col.field !== ""
    );

    const sortBySelectList = this.processSortBySelectList(cloneDeepColumn);

    const thenSelectList = this.processThenSelectList(cloneDeepColumn);

    const endSelectList = this.processEndSelectList(cloneDeepColumn);

    const options = {
      defaultSortName,
      defaultSortOrder,
      sizePerPage,
      totalRecord,
      currentPage
    };

    const customHeader = (
      <div className="table-header">
        <Row>
          <Col
            sm={12}
            md={12}
            className="text-right table-header-change-column"
          >
            <AdvancedSort
              isDisplayAdvancedSortDialog={isDisplayAdvancedSortDialog}
              sortBy={sortBy}
              sortByOrder={sortByOrder}
              then={then}
              thenOrder={thenOrder}
              end={end}
              endOrder={endOrder}
              handleClickAdvancedButton={this.handleClickAdvancedButton}
              handleApplyAdvancedSort={this.handleApplyAdvancedSort}
              onSelectChange={this.onSelectChange}
              sortBySelectList={sortBySelectList}
              thenSelectList={thenSelectList}
              endSelectList={endSelectList}
              orderSelectList={orderSelectList}
            />
            <ChangeColumn
              columnList={column}
              settingColumn={this.state.settingColumn}
              onChangeColumn={this.onChangeColumn}
              except={["id"]}
            />
            <ExportButton onClick={this.handleExport} />
            <div className="box-search" style={{ margin: 0 }}>
              <div className="input-group">
                <input
                  type="text"
                  id="txt-search-email"
                  ref={ref => {
                    this.search = ref;
                  }}
                  value={searchTxt}
                  onChange={this.onChangeSearchTxt}
                  className="form-control"
                  placeholder="lot #/street address"
                  onKeyPress={this.onEnter.bind(this)}
                />
                <span className="input-group-btn">
                  <button
                    onClick={this.onSearch.bind(this)}
                    className="btn btn-secondary"
                  >
                    <span className="fa fa-search" aria-hidden="true" />
                  </button>
                </span>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );

    return (
      <div id="manage-user">
        {AppSettings.clientTypeValue !== "Homeowner" && [
          <div className="page-title clearfix" key="header-lot">
            <h2 className="pull-left">
              <Translate translateKey="lot" plurals capitalize /> (
              {this.props.LotStore.ManageLots.params.totalRecord})
            </h2>
            <span
              className="btn btn-primary btn-info btn-siteone pull-right btn-icon"
              onClick={() => this.setState({ isOpenAddModal: true })}
            >
              <span className="fa fa-plus icon" />
              NEW
            </span>
          </div>,
          <LotFilter
            key={"lot-filter"}
            onFetchRegion={this.onFetchRegion}
            RegionSelectList={this.props.SelectListRegions}
            onFetchMarket={this.onFetchMarket}
            MarketSelectList={this.props.SelectListMarkets}
            onFetchProject={this.onFetchProject}
            ProjectSelectList={this.props.SelectListProject}
            onFetchHomeowner={this.onFetchHomeowner}
            HomeownerSelectList={this.props.SelectListHomeowner}
            onSearchLot={this.onSearchLot}
            location={this.props.location}
          />
        ]}

        <ContextMenu
          ref={ref => {
            this.cxtMenu = ref;
          }}
        />
        <MessengerBox
          ref={ref => {
            this.msgBox = ref;
          }}
          title={AppSettings.COMPANY_NAME}
        />

        {this.props.UserProfile.userId && (
          <TableList
            ref={ref => {
              this.tableList = ref;
            }}
            column={column}
            defaultParams={defaultParams}
            data={data}
            options={options}
            refreshPageList={this.refreshList.bind(this)}
            refreshList={this.refreshList.bind(this)}
            showButtonMenu={true}
            customTableHeader={customHeader}
            caretRender={this.getCaret}
            isDisplayTable={this.state.isDisplayTable}
            applySkeleton={true}
          />
        )}

        <AddNewLotModal
          ref={ref => {
            this.addModal = ref;
          }}
          isOpen={this.state.isOpenAddModal}
          onFetchProject={this.onFetchProject}
          SelectListProject={this.props.SelectListProject}
          onFetchPhase={this.onFetchPhase}
          SelectListPhase={this.props.SelectListPhase}
          onFetchPlan={this.onFetchPlan}
          onFetchCostCode={this.onFetchCostCode}
          SelectListPlan={this.props.SelectListPlan}
          onFetchInsurance={this.onFetchInsurance}
          SelectListInsurance={this.props.SelectListInsurance}
          ErrorMsg={this.props.LotStore.ErrorMsg}
          onCloseModal={this.onCloseModalAddNewLot}
          onSubmit={this.onSubmitModalAddNewLot}
          SelectListCostCodes={this.props.SelectListCostCodes}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    LotStore: state.LotStore,
    SelectListRegions: state.RegionMarketStore.SelectListRegions,
    SelectListMarkets: state.RegionMarketStore.SelectListMarkets,
    SelectListProject: state.ProjectStore.ProjectList,
    SelectListPhase: state.PhaseStore.SelectListPhase,
    SelectListPlan: state.ModelStore.SelectListPlan,
    SelectListInsurance: state.InsurancePolicyStore.SelectListInsurancePolicy,
    SelectListCostCodes: state.LotStore.SelectListCostCodes,
    SelectListHomeowner: state.HomeOwnersStore.SelectListHomeowner,
    UserProfile: state.UserStore.UserProfile,
    SettingDataGridColumn: state.BuilderStore.SettingDataGridColumn,
    PageSizeReference: state.BuilderStore.PageSizeReference
  };
};

export default connect(mapStateToProps)(CreateNewLot);



// WEBPACK FOOTER //
// ./src/Lots/Containers/manage-create-new-lot.js